import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Facility = {
    _v1: {
        getFacility: { method: HttpMethod.GET, path: '/v1/get-facility' },
        getQuaiFacilities: { method: HttpMethod.GET, path: '/v1/get-quai-facilities' },
    }
};
//# sourceMappingURL=api-def.js.map